import { render, staticRenderFns } from "./AdminTrailerFilters.vue?vue&type=template&id=4de38e13"
import script from "./AdminTrailerFilters.vue?vue&type=script&lang=js"
export * from "./AdminTrailerFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports